module.exports = __webpack_public_path__ + "img/await.fb54f989.svg";